import { Loader } from '../../components/Loader';
import { isWithinSixtyDays, sortByExpiryDate } from "../../tools/utils";
import useIsMobile from '../../hooks/Helper/useIsMobile';
import { useGlobalContext } from '../../hooks/Helper/GlobalContext';
import { Credentials, MyCredentials } from '../../types/allcredential';
import React, { useEffect } from 'react';
import { NotificationBanner } from '../../components/NotificationBanner/NotificationBanner';
import { ContactCredentialCard } from '../../components/Cards/ContactCredentialCard';
import { useTranslation } from 'react-i18next';
import CredentialShare from '../../components/Common/CredentialShare';
import { useMyCredentials } from '../../hooks/useMyCredentials';
import { ProfileCard } from '../../components/Dashboard/ProfileCard';
import { getUser } from '../../redux/slices/contactSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';


export const TestingPersonnel = ({ headerMarginTop }: { headerMarginTop: number }) => {
  const {ProviderAccessControl,Color,ProviderBannerColor,ProviderBannerMessage,FullName,CandidateId,photoBannerVisible,PhotoBannerMessage }=useGlobalContext();
  const {t}=useTranslation();
  const isMobile = useIsMobile();
  const credentials = useMyCredentials();
  const userCredentials = credentials?.data?.data?.Data;
  const credentialsWithBorder =userCredentials &&  userCredentials.filter(item =>
    isWithinSixtyDays(item.EarnedCredential.ExpiryDate)
) as MyCredentials[] | undefined;

const credentialsWithoutBorder =userCredentials && userCredentials.filter(item =>
    !isWithinSixtyDays(item.EarnedCredential.ExpiryDate)
);


  const credentialGroupedData = credentialsWithoutBorder && credentialsWithoutBorder
    .sort((a, b) => a.EarnedCredential.GroupOrder - b.EarnedCredential.GroupOrder)
    .reduce((groups: any, item) => {
      const { GroupName } = item.EarnedCredential;
      if (!groups[GroupName]) {
        groups[GroupName] = [];
      }
      groups[GroupName].push(item.EarnedCredential);
      return groups;
    }, {});

    const credentialGroup: Array<{ [x: string]: unknown; }> = credentialGroupedData && Object.entries(credentialGroupedData).map(([GroupName, groupItems]) => ({
      [GroupName]: groupItems,
    }));
    const candidateBannerVisible = ProviderAccessControl ? (ProviderAccessControl !== 'Normal' && ProviderAccessControl !== 'Watched') : false;
  
    const getMarginTop = () => {
      if ( candidateBannerVisible && isMobile) {
          return "230px";  // Both banners are visible on mobile
      } 
    
   else {
          return "";  // No banner is visible
      }
  };
  const { contact,loading,error} = useSelector((state: RootState) => state.contact);
  const dispatch = useDispatch<AppDispatch>();
    useEffect(() => {
       if(contact===null && !loading && !error){
        dispatch(getUser());
       }
    },[]);

  return (
    <div id="main-content" style={{ marginTop: headerMarginTop }}>
    <div className="cco_content_area cco_content_area_0">
    <article className="react-container" >
               <NotificationBanner
                background="red"
                showBanner={photoBannerVisible}
                message={PhotoBannerMessage}
                color="white"
                type="photo"
                isMobile={isMobile}
            />
    <NotificationBanner
                background={ProviderBannerColor}
                showBanner={ProviderAccessControl ?(ProviderAccessControl !== 'Normal' && ProviderAccessControl !== 'Watched') : false}
                message={ProviderBannerMessage}
                isPhotoVisible={photoBannerVisible}
                type="ac"
                color={Color}
                isMobile={isMobile}
            />

      <div        className={ (ProviderAccessControl && ProviderAccessControl !== 'Normal' && ProviderAccessControl !== 'Watched')
                        ? 'cco_section bannerVisible'
                        : 'cco_section cco_section_3'
                }>
{ProviderAccessControl !== 'Locked' && (
   <>
   
   <div  style={{
                    marginTop: getMarginTop()}}>
      <div className="cco_row cco_row_4"  >
        <div className="cco_col">
          <div className="cco_text cco_text_0">
            <div className="cco_text_inner">
              <strong>{t("testingPersonnel.pageHeading")}</strong>
            </div>
          </div>
        </div>
      </div>

      <ProfileCard />
   <div className="cco_row cco_row_7">
                <div className="cco_col cco_col_6">
                  <div className="cco_text cco_text_10">
                    <div className="cco_text_inner">
                     
                      <p>
  {t('testingPersonnel.DescriptionPart1')}
  <a
    href="https://www.nccco.org/EOTcredentials"
    target="_blank"
    rel="noopener noreferrer"
  >
    {t('testingPersonnel.DescriptionLinkText')}
  </a>
  {t('testingPersonnel.DescriptionPart2')}
</p>
                      
                       
                    </div>
                  </div>
                </div>
              </div>
      {credentialsWithBorder && credentialsWithBorder.length > 0 && (
      <React.Fragment>

    <div className="cco_row cco_row_7">
      <div className="cco_col cco_col_6">
        <div className="cco_text cco_text_10">
          <div
            className="cco_text_inner"
            style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}
          >
            <h2><strong>My Trainings Due Now</strong></h2>
          </div>
        </div>
      </div>
    </div>


  <div className="cco_row cco_row_38">
    <div className="cco_col">
      {credentials.isLoading ? (
        <Loader />
      ) : credentials.error ? (
        <p>{credentials.error.message}</p>
      ) : credentialsWithBorder && credentialsWithBorder.length > 0 ? (
        <div className="cco_group cco_group_myCredential">
          {sortByExpiryDate(credentialsWithBorder).map((credential, index) => (
            <ContactCredentialCard
              key={credential.EarnedCredential.ContactCredentialId}
              credential={credential.EarnedCredential}
              index={index}
              ProviderAccessControl={ProviderAccessControl}
            />
          ))}
        </div>
      ) : (
        <p>{t("testingPersonnel.noCredential")}</p>
      )}
    </div>
  </div>
</React.Fragment>
  )}


  

      {credentialGroup && credentialGroup.map((group: any, index: number) => (
        <React.Fragment key={group + index}>
          <div className="cco_row cco_row_7">
            <div className="cco_col cco_col_6">
              <div className="cco_text cco_text_10">
                <div className="cco_text_inner" style={{ display: 'flex', alignItems: 'center' ,marginLeft: '10px' }}>
                <h2><strong>My {Object.keys(group)[0]}</strong></h2>
                  {Object.keys(group)[0]==="Practical Proctor Credential Designations" && <CredentialShare CCOID={CandidateId} Name={FullName} />}
                </div>
              </div>
            </div>
          </div>

          <div className="cco_row cco_row_38">
            <div className="cco_col">
              {credentials.isLoading ? (
                <Loader />
              ) : credentials.error ? (
                <p>{credentials.error.message}</p>
              ) : group && group[Object.keys(group)[0]].length > 0 ? (
                <div className="cco_group cco_group_myCredential" >
                  {group[Object.keys(group)[0]]
                  .sort((a: { CredentialOrder: number; }, b: { CredentialOrder: number; }) => a.CredentialOrder - b.CredentialOrder)
                  .map((credential: Credentials,index:number) => (
                                                          
                    <ContactCredentialCard 
                    credential={credential}
                    index={index}
                    ProviderAccessControl={ProviderAccessControl}
                    />
                  ))}
          </div>
              ) : (
                <p>{t("testingPersonnel.noCredential")}</p>
              )}
            </div>
          </div>
        </React.Fragment>
      ))}




      {/*Available Credential  */}
      <div className="cco_row cco_row_2">
        <div className="cco_col">
          <div className="cco_text cco_text_2">
            <div className="cco_text_inner">
              {/* <h2>Available Credentials</h2> */}

            </div>
          </div>
        </div>
      </div>
  {ProviderAccessControl !== 'Suspended' && (
  <> 

      {credentials.isLoading ? (
        <div className='cco_row cco_row_3'>
          <Loader />
        </div>
      ) : credentials.error ? (
        <p>{credentials.error.message}</p>
      ) : (
        <div className="cco_row cco_row_3" style={{ backgroundColor: 'white' }}>
          <div className="cco_col">
            <div className="cco_group cco_group_2" >
              <div className="cco_group_item" >
                <ul className="cco_menu cco_menu_6" style={{ textAlign: 'center' }}>
                  <li className="cco_menu_item cco_menu_item_primary" style={{ marginBottom: "0px" }}  >
                  <a
                    className={`${ProviderAccessControl === 'Suspended' ? 'btn-disabled' : ''}`}
                    style={{ height: "auto" }}
                    href={ProviderAccessControl === 'Suspended' ? '' : '/credential-journey'}
                    onClick={(e) => {
                      if (ProviderAccessControl === 'Suspended') {
                        e.preventDefault();
                      }
                    }}
                    
                  >{t("testingPersonnel.credentialJourneyButton")}</a>
                    <div style={{ textAlign: "center" }}>
                      <span>
                      <a
                       className='ccolinks'
                       style={{ color: ProviderAccessControl === 'Suspended' ? 'grey' : '' }}
                       href={ProviderAccessControl === 'Suspended' ? '' : '/available-credentials'}
                       onClick={(e) => {
                        if (ProviderAccessControl === 'Suspended') {
                          e.preventDefault();
                        }
                      }}
                      >{t("testingPersonnel.availableCredentialButton")}</a>
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
 </>
   )}
</div>
    </>
    
)}
    </div> 
  
    </article>
    </div>
    </div>
  );
};